import ShambhuKumar from "./ShambhuKumar";

function App() {
  return <ShambhuKumar />;
}

export default App;